import platform from '@propertypal/shared/src/utils/platform';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import SpecialistConsultancyFeatures from '@propertypal/web-ui/src/products/SpecialistConsultancyFeatures';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: `Specialist Consultancy - ${platform.title}`,
  description:
    'Our Team Of Data Specialists Is Ready To Understand Your Business Needs And Provide Bespoke Data Analysis Reports To Support Your Investment Strategy And Decisions.',
  url: `/products/estate-agents/specialist-consultancy`,
};

const AgentSpecialistConsultancy = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <SpecialistConsultancyFeatures />
      <ProductsContact reason="Estate Agents Specialist Consultancy" />
    </>
  );
};

export default AgentSpecialistConsultancy;
